<template>
  <section>
    <section-header
      @toggle="showSection = !showSection"
      @showSort="showSortModal = true"
      :showSection="showSection"
      :section="section"
      :showSort="true"
      :showAdd="true">
      <slot></slot>
    </section-header>

    <div class="content" v-show="showSection && items.length > 0">

      <div class="text-center">
        <h6 class="d-inline" v-for="dice in dicePool" :key="dice">
          <ez-modal-dice class="bold"
            slot="underline"
            :name="dice"
            :dice="`1${dice}`">
            {{dice}}
          </ez-modal-dice>
        <span class="c3" v-if="dice !== 'd100'"> / </span></h6>
      </div>

      <action class="item-row rule-indent"
        v-for="item in noType"
        :item="item"
        :attackBonus="attackBonus(item)"
        :damageBonus="damageBonus(item)"
        @setId="editId = item._id"
        :ruleset="ruleset"
        :key="item._id">
      </action>

      <div v-for="actionType in this.$rpgv.actionTypes.filter(x => x !== '')" :key="actionType">
        <h6 v-if="actionTypeSorted(actionType).length > 0" class="rule">{{actionType}}</h6>
        <action class="item-row rule-indent"
          v-for="item in actionTypeSorted(actionType)"
          :item="item"
          :attackBonus="attackBonus(item)"
          :damageBonus="damageBonus(item)"
          @setId="editId = item._id"
          :ruleset="ruleset"
          :key="item._id">
        </action>
      </div>
    </div>

    <ez-modal v-if="showEditModal" @close="closeEdit()" size="m-medium">
      <h3>Action</h3>
      <default 
        :section="section" 
        :item="editItem"
        :attackBonus="attackBonus(editItem)"
        :damageBonus="damageBonus(editItem)"
        :ruleset="ruleset">
      </default>
      <clone-delete-item
        :section="section"
        :item="editItem"
        @close="closeEdit()">
      </clone-delete-item>
    </ez-modal>

    <ez-modal v-if="showSortModal" @close="showSortModal = false" size="m-tiny">
      <h3>Actions</h3>
      <sortable :section="section" :items="items"></sortable>
    </ez-modal>
  </section>
</template>
<script>
import { mapState } from "vuex";
import Action from "./_Action.vue";
import CloneDeleteItem from "../shared/_CloneDeleteItem.vue";
import Default from "./_Default.vue";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import SectionHeader from "../shared/_SectionHeader.vue";
import Sortable from "../shared/_Sortable.vue";
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "sheet-actions-index",
  mixins: [modal],
  components: {
    Action,
    CloneDeleteItem,
    Default,
    EzModalDice,
    SectionHeader,
    Sortable
  },
  data() {
    return {
      section: "actions",
      editId: null,
      editItem: null,
      showSection: true,
      showEditModal: false,
      showSortModal: false,
      dicePool: ["d4", "d6", "d8", "d10", "d12", "d20", "d100"]
    };
  },
  watch: {
    editId: "showEdit"
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      items: state => state.characters.current.actions,
      attributes: state => state.characters.current.attributes,
      experience: state => state.characters.current.core.experience,
      baseAttackBonus: state => state.characters.current.core.baseAttackBonus,
      size: state => state.characters.current.core.size,
      skills: state => state.characters.current.skills,
      health: state => state.characters.current.defense.health
    }),
    actionTypes() {
      let options = [];
      /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
      this.$rpgv.actionTypes.forEach(element => {
        options.push({ text: element, value: element });
      });
      return options;
    },
    noType() {
      let actions = this.items.filter(
        x => x.type === null || x.type === "" || x.type === undefined
      );
      return actions;
    }
  },
  methods: {
    closeEdit() {
      this.showEditModal = false;
      this.editId = null;
    },
    showEdit() {
      if (this.editId) {
        this.editItem = this.items.find(x => x._id === this.editId);
        this.showEditModal = true;
      }
    },
    filtered(filter) {
      let list = this.items.filter(value => {
        return value.type === filter;
      });
      return list;
    },
    actionTypeSorted(v) {
      let actions = this.items.filter(x => x.type === v);
      return actions;
    },
    getAttribute(attribute) {
      return this.attributes.find(x => x.name === attribute);
    },
    attackBonus(item) {
      let payload = {};
      if (["Savage Embers", "Savage Worlds"].includes(this.ruleset)) {
        let skill = this.skills.find(
          x => x.name.toLowerCase() === item.attack.skill
        );
        payload.skill = skill;
        payload.attack = item.attack;
        payload.health = this.health;
      } else {
        let attribute = this.$rulesets[this.ruleset].getAttribute(
          item.attack.attribute,
          this.attributes
        );

        payload.experience = this.experience;
        payload.item = item;
        payload.attribute = attribute;
        payload.size = this.size;
        payload.baseAttackBonus = this.baseAttackBonus;
      }

      return this.$rulesets[this.ruleset].getAttackBonus(payload);
    },
    damageBonus(item) {
      let attribute = this.$rulesets[this.ruleset].getAttribute(
        item.damage.attribute,
        this.attributes
      );

      let payload = {
        damage: item.damage,
        attribute: attribute
      };

      return this.$rulesets[this.ruleset].getDamageBonus(payload);
    }
  }
};
</script>
